import{i as s}from"../isFunction-8a46d21f.js";import"../_baseGetTag-852b3600.js";import"../_commonjsHelpers-3a7f7302.js";import"../isObject-0b530d86.js";var o=s;export{o as isFunction};
//# sourceMappingURL=is-function.js.map
